import styled from 'styled-components';

export const StyledOutletWrapper = styled.span`
  display: inline;
`;
